export const HS_WEB_BASE_URL = 'https://stg-api.homesmartify.co';
export const environment = {
    production: true
};
  